// extracted by mini-css-extract-plugin
module.exports = {"button":"ZoinkLogo_button__2Rifx","full-width-avatar":"ZoinkLogo_full-width-avatar__2aT4l","zoinkWrapper":"ZoinkLogo_zoinkWrapper__2B93d"};